(() => {
  'use strict';

  const BODY_CLASS = 'mr-best-phone-deals-page';
  const state = new WeakMap();

  function addBodyClass() {
    document.body.classList.add(BODY_CLASS);
  }

  function setupTopCarousel(root) {
    if (!root || root.dataset.mrCarouselReady === 'true') return;

    const track = root.querySelector('[data-mr-deals-carousel]');
    const prev = root.querySelector('[data-mr-deals-prev]');
    const next = root.querySelector('[data-mr-deals-next]');
    if (!track) return;

    root.dataset.mrCarouselReady = 'true';

    const getStep = () => {
      const card = track.querySelector('.mr-deal-card');
      if (!card) return Math.max(track.clientWidth * 0.75, 240);
      const style = window.getComputedStyle(track);
      const gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      if (!prev || !next) return;
      const max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };

    prev?.addEventListener('click', () => {
      track.scrollBy({ left: -getStep() * 2, behavior: 'smooth' });
    });
    next?.addEventListener('click', () => {
      track.scrollBy({ left: getStep() * 2, behavior: 'smooth' });
    });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();
  }

  function inferCondition(title) {
    const text = (title || '').toLowerCase();
    if (
      text.includes('pre-owned') ||
      text.includes('pre owned') ||
      text.includes('used') ||
      text.includes('refurb')
    ) return 'Pre-Owned';
    return 'Brand New';
  }

  function enhanceProductCards(scope = document) {
    scope.querySelectorAll('.product-item').forEach((card) => {
      if (card.dataset.mrDealCardReady === 'true') return;

      const heading = card.querySelector('.card-title, .card__heading a');
      const title = heading?.textContent?.trim() || '';
      const actionButton = card.querySelector(
        'button[name="add"], .product-form__submit, form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"]'
      );

      let stockText = '';
      let soldOut = false;
      if (actionButton) {
        const buttonText = (actionButton.textContent || '').trim().toLowerCase();
        soldOut = actionButton.disabled || buttonText.includes('sold out') || buttonText.includes('unavailable');
        stockText = soldOut ? 'Sold Out' : 'In Stock';
      }

      const infoWrapper = card.querySelector('.card-information__wrapper') || card.querySelector('.card-information');
      if (infoWrapper && !infoWrapper.querySelector('.mr-grid-meta')) {
        const meta = document.createElement('div');
        meta.className = 'mr-grid-meta';

        const condition = document.createElement('span');
        condition.className = 'mr-grid-condition';
        condition.textContent = inferCondition(title);
        meta.appendChild(condition);

        if (stockText) {
          const stock = document.createElement('span');
          stock.className = `mr-grid-stock${soldOut ? ' is-sold' : ''}`;
          stock.textContent = stockText;
          meta.appendChild(stock);
        }
        infoWrapper.appendChild(meta);
      }

      card.dataset.mrDealCardReady = 'true';
    });
  }

  function enhanceSidebar(scope = document) {
    const sidebarWrapper = scope.querySelector('#halo-sidebar .halo-sidebar-wrapper');
    if (!sidebarWrapper || sidebarWrapper.querySelector('.mr-deals-filter-head')) return;

    const head = document.createElement('div');
    head.className = 'mr-deals-filter-head';

    const title = document.createElement('strong');
    title.textContent = 'FILTER BY';

    const clear = document.createElement('a');
    clear.textContent = 'Clear All';
    clear.href = window.location.pathname;
    clear.dataset.mrClearAll = 'true';

    head.append(title, clear);
    sidebarWrapper.prepend(head);
  }

  function enhanceToolbar(scope = document) {
    const toolbar = scope.querySelector('toolbar-item.toolbar');
    if (!toolbar) return;

    const results = toolbar.querySelector('.results-count .results');
    if (results && results.dataset.mrResultsReady !== 'true') {
      const countNode = results.querySelector('.count');
      const count = countNode ? countNode.textContent.trim() : '';
      results.innerHTML = count
        ? `All Deals (<span class="count">${count}</span> Products)`
        : 'All Deals';
      results.style.display = 'inline-flex';
      results.dataset.mrResultsReady = 'true';
    }

    const sortLabel = toolbar.querySelector('.toolbar-sort .toolbar-label');
    if (sortLabel && sortLabel.dataset.mrSortLabelReady !== 'true') {
      sortLabel.textContent = 'Sort By:';
      sortLabel.dataset.mrSortLabelReady = 'true';
    }
  }

  function enhanceCollection(scope = document) {
    enhanceSidebar(scope);
    enhanceToolbar(scope);
    enhanceProductCards(scope);
  }

  function setupFaq() {
    document.querySelectorAll('.mr-deals-faq').forEach((faq) => {
      if (faq.dataset.mrFaqReady === 'true') return;
      faq.dataset.mrFaqReady = 'true';
      faq.addEventListener('toggle', (event) => {
        const current = event.target;
        if (!(current instanceof HTMLDetailsElement) || !current.open) return;
        faq.querySelectorAll('details[open]').forEach((item) => {
          if (item !== current) item.removeAttribute('open');
        });
      }, true);
    });
  }

  function cleanParams(params) {
    const cleaned = new URLSearchParams();
    params.forEach((value, key) => {
      if (value !== '' && value != null) cleaned.append(key, value);
    });
    return cleaned;
  }

  function pageParamsFromLocation() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    params.delete('sections');
    return params;
  }

  function syncPageUrl(params) {
    const qs = params.toString();
    const next = `${window.location.pathname}${qs ? `?${qs}` : ''}${window.location.hash || ''}`;
    window.history.replaceState({}, '', next);
  }

  function buildCollectionUrl(host, params) {
    const base = host.dataset.collectionUrl || '/collections/all';
    const url = new URL(base, window.location.origin);
    const cleaned = cleanParams(params || new URLSearchParams());
    url.search = cleaned.toString();
    return url;
  }

  function findCollectionPayload(doc) {
    const section = doc.querySelector('[id^="CollectionSection-"]');
    if (!section) return null;

    const shopifySection = section.closest('.shopify-section');
    const source = shopifySection || section;
    const clone = source.cloneNode(true);

    clone.querySelectorAll('script').forEach((node) => node.remove());
    return clone;
  }

  async function fetchCollection(host, params, { append = false } = {}) {
    const current = state.get(host) || {};
    current.requestId = (current.requestId || 0) + 1;
    const requestId = current.requestId;
    state.set(host, current);

    host.classList.add('is-loading');
    const loading = host.querySelector('[data-mr-products-loading]');
    const content = host.querySelector('[data-mr-products-content]');
    if (!content) return;
    if (!content.children.length && loading) loading.hidden = false;

    const url = buildCollectionUrl(host, params);
    try {
      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      if ((state.get(host)?.requestId || 0) !== requestId) return;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const payload = findCollectionPayload(doc);
      if (!payload) throw new Error('Collection grid not found in backing collection response.');

      if (append) {
        const currentGrid = content.querySelector('#main-collection-product-grid');
        const nextGrid = payload.querySelector('#main-collection-product-grid');
        if (currentGrid && nextGrid) {
          nextGrid.querySelectorAll(':scope > .product').forEach((item) => currentGrid.appendChild(item));

          const currentPagination = content.querySelector('.pagination-wrapper');
          const nextPagination = payload.querySelector('.pagination-wrapper');
          if (currentPagination && nextPagination) {
            currentPagination.replaceWith(nextPagination);
          } else if (currentPagination && !nextPagination) {
            currentPagination.remove();
          } else if (!currentPagination && nextPagination) {
            currentGrid.parentElement?.appendChild(nextPagination);
          }

          enhanceCollection(content);
        } else {
          content.replaceChildren(payload);
          enhanceCollection(content);
        }
      } else {
        content.replaceChildren(payload);
        enhanceCollection(content);
      }

      if (loading) loading.hidden = true;
      host.classList.remove('is-loading');
    } catch (error) {
      console.error('[MR Best Phone Deals]', error);
      if (loading) loading.hidden = true;
      host.classList.remove('is-loading');
      content.innerHTML = `
        <div class="mr-deals-products__error">
          Phone deals could not be loaded right now.
          <a href="${host.dataset.collectionUrl || '/collections/all'}">Open the collection</a>
        </div>`;
    }
  }

  function paramsFromFilterForm(host) {
    const form = host.querySelector('#CollectionFiltersForm');
    const params = form ? new URLSearchParams(new FormData(form)) : new URLSearchParams();
    const current = pageParamsFromLocation();
    if (current.has('sort_by')) params.set('sort_by', current.get('sort_by'));
    return cleanParams(params);
  }

  function getUrlParamsFromHref(href) {
    const url = new URL(href, window.location.origin);
    url.searchParams.delete('page');
    return cleanParams(url.searchParams);
  }

  function setupSortDropdown(host) {
    host.querySelectorAll('.toolbar-dropdown .label-tab').forEach((tab) => {
      if (tab.dataset.mrDropdownReady === 'true') return;
      tab.dataset.mrDropdownReady = 'true';
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        const dropdown = tab.closest('.toolbar-dropdown');
        dropdown?.classList.toggle('is-open');
        const menu = dropdown?.querySelector('.dropdown-menu');
        if (menu) menu.classList.toggle('is-show');
      });
    });
  }

  function setupPageProducts(host) {
    if (!host || host.dataset.mrProductsReady === 'true') return;
    host.dataset.mrProductsReady = 'true';

    const content = host.querySelector('[data-mr-products-content]');
    if (!content) return;

    host.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;
      if (!target.closest('#CollectionFiltersForm')) return;

      const params = paramsFromFilterForm(host);
      syncPageUrl(params);
      fetchCollection(host, params);
    });

    host.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const clearAll = target.closest('[data-mr-clear-all="true"]');
      if (clearAll) {
        event.preventDefault();
        const params = new URLSearchParams();
        const current = pageParamsFromLocation();
        if (current.has('sort_by')) params.set('sort_by', current.get('sort_by'));
        syncPageUrl(params);
        fetchCollection(host, params);
        return;
      }

      const remove = target.closest('a.js-facet-remove');
      if (remove) {
        event.preventDefault();
        const params = getUrlParamsFromHref(remove.href);
        syncPageUrl(params);
        fetchCollection(host, params);
        return;
      }

      const priceApply = target.closest('#filter__price--apply, .filter__price--apply');
      if (priceApply) {
        event.preventDefault();
        const params = paramsFromFilterForm(host);
        syncPageUrl(params);
        fetchCollection(host, params);
        return;
      }

      const sortItem = target.closest('[data-sort-by-item]');
      if (sortItem) {
        event.preventDefault();
        const valueNode = sortItem.querySelector('[data-value]') || target.closest('[data-value]');
        const value = valueNode?.getAttribute('data-value');
        if (value) {
          const params = pageParamsFromLocation();
          params.set('sort_by', value);
          syncPageUrl(params);
          fetchCollection(host, params);
        }
        return;
      }

      const paginationLink = target.closest('.pagination-wrapper a[href], .pagination-wrapper [data-href]');
      if (paginationLink) {
        const href = paginationLink.getAttribute('href') || paginationLink.getAttribute('data-href');
        if (!href) return;
        const url = new URL(href, window.location.origin);
        if (!url.searchParams.has('page')) return;

        event.preventDefault();
        const isLoadMore = /load more|show more/i.test(paginationLink.textContent || '') ||
          paginationLink.matches('[data-load-more-product], [data-load-more]');

        const params = cleanParams(url.searchParams);
        if (isLoadMore) {
          fetchCollection(host, params, { append: true });
        } else {
          syncPageUrl(params);
          fetchCollection(host, params);
          host.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
    });

    const observer = new MutationObserver(() => {
      enhanceCollection(content);
      setupSortDropdown(host);
    });
    observer.observe(content, { childList: true, subtree: true });

    const initial = pageParamsFromLocation();
    fetchCollection(host, initial).then(() => setupSortDropdown(host));
  }

  function observeNativeCollection() {
    const grid = document.getElementById('CollectionProductGrid');
    if (!grid || grid.closest('[data-mr-products-host]') || grid.dataset.mrObserverReady === 'true') return;
    grid.dataset.mrObserverReady = 'true';
    const observer = new MutationObserver(() => {
      window.requestAnimationFrame(() => enhanceCollection(document));
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  function init() {
    addBodyClass();
    document.querySelectorAll('[data-mr-deals-root]').forEach(setupTopCarousel);
    document.querySelectorAll('[data-mr-products-host]').forEach(setupPageProducts);
    enhanceCollection(document);
    observeNativeCollection();
    setupFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
